import { c as _createClass, b as _classCallCheck, _ as _inherits, a as _createSuper, d as _defineProperty, e as _assertThisInitialized } from './createClass-3115abc1.esm.js';
import { _ as _wrapNativeSuper } from './wrapNativeSuper-76ffa30e.esm.js';

var TransactionKind;
(function (TransactionKind) {
  TransactionKind["APPROVE_MODULE"] = "APPROVE_MODULE";
  TransactionKind["COLLECT_PUBLICATION"] = "COLLECT_PUBLICATION";
  TransactionKind["CREATE_COMMENT"] = "CREATE_COMMENT";
  TransactionKind["CREATE_POST"] = "CREATE_POST";
  TransactionKind["CREATE_PROFILE"] = "CREATE_PROFILE";
  TransactionKind["FOLLOW_PROFILES"] = "FOLLOW_PROFILES";
  TransactionKind["MIRROR_PUBLICATION"] = "MIRROR_PUBLICATION";
  TransactionKind["UPDATE_PROFILE_IMAGE"] = "UPDATE_PROFILE_IMAGE";
  TransactionKind["UNFOLLOW_PROFILE"] = "UNFOLLOW_PROFILE";
  TransactionKind["UPDATE_PROFILE_DETAILS"] = "UPDATE_PROFILE_DETAILS";
  TransactionKind["UPDATE_FOLLOW_POLICY"] = "UPDATE_FOLLOW_POLICY";
  TransactionKind["UPDATE_DISPATCHER_CONFIG"] = "UPDATE_DISPATCHER_CONFIG";
})(TransactionKind || (TransactionKind = {}));
var UnsignedTransaction = /*#__PURE__*/_createClass(function UnsignedTransaction(id, chainType, request) {
  _classCallCheck(this, UnsignedTransaction);
  this.id = id;
  this.chainType = chainType;
  this.request = request;
});
var SignedProtocolCall = /*#__PURE__*/function () {
  function SignedProtocolCall(id, signature, request, nonce) {
    _classCallCheck(this, SignedProtocolCall);
    this.id = id;
    this.signature = signature;
    this.request = request;
    this.nonce = nonce;
  }
  _createClass(SignedProtocolCall, null, [{
    key: "create",
    value: function create(_ref) {
      var id = _ref.id,
        signature = _ref.signature,
        request = _ref.request,
        nonce = _ref.nonce;
      return new SignedProtocolCall(id, signature, request, nonce);
    }
  }]);
  return SignedProtocolCall;
}();
var TransactionEvent;
(function (TransactionEvent) {
  TransactionEvent["BROADCASTED"] = "BROADCASTED";
  TransactionEvent["UPGRADED"] = "UPGRADED";
  TransactionEvent["SETTLED"] = "SETTLED";
})(TransactionEvent || (TransactionEvent = {}));
var ProxyActionStatus;
(function (ProxyActionStatus) {
  ProxyActionStatus["MINTING"] = "MINTING";
  ProxyActionStatus["TRANSFERRING"] = "TRANSFERRING";
  ProxyActionStatus["COMPLETE"] = "COMPLETE";
})(ProxyActionStatus || (ProxyActionStatus = {}));
var MetaTransaction = /*#__PURE__*/_createClass(function MetaTransaction() {
  _classCallCheck(this, MetaTransaction);
});
var NativeTransaction = /*#__PURE__*/_createClass(function NativeTransaction() {
  _classCallCheck(this, NativeTransaction);
});
var ProxyTransaction = /*#__PURE__*/_createClass(function ProxyTransaction() {
  _classCallCheck(this, ProxyTransaction);
});
var TransactionErrorReason;
(function (TransactionErrorReason) {
  TransactionErrorReason["CANNOT_EXECUTE"] = "CANNOT_EXECUTE";
  TransactionErrorReason["INDEXING_TIMEOUT"] = "INDEXING_TIMEOUT";
  TransactionErrorReason["MINING_TIMEOUT"] = "MINING_TIMEOUT";
  TransactionErrorReason["REJECTED"] = "REJECTED";
  TransactionErrorReason["REVERTED"] = "REVERTED";
  TransactionErrorReason["UNKNOWN"] = "UNKNOWN";
})(TransactionErrorReason || (TransactionErrorReason = {}));
var TransactionError = /*#__PURE__*/function (_Error) {
  _inherits(TransactionError, _Error);
  var _super = _createSuper(TransactionError);
  function TransactionError(reason) {
    var _this;
    _classCallCheck(this, TransactionError);
    _this = _super.call(this, "Transaction failed due to: ".concat(reason));
    _defineProperty(_assertThisInitialized(_this), "name", 'TransactionError');
    _this.reason = reason;
    return _this;
  }
  return _createClass(TransactionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { MetaTransaction as M, NativeTransaction as N, ProxyActionStatus as P, SignedProtocolCall as S, TransactionKind as T, UnsignedTransaction as U, TransactionError as a, TransactionErrorReason as b, ProxyTransaction as c, TransactionEvent as d };
